/** @format */

import styled from "styled-components";
import { colors } from "../../../css/variables/colors";
import { mixins } from "../../../css/variables/mixins";
import AnotherTabLink from "../AnotherTabLink/AnotherTabLink";
import { ReactNode } from "react";

const TableWrapper = styled.table`
  width: 65%;
  ${mixins.screenUnder()} {
    width: 100%;
  }
`;

type innerTdType = {
  num: number;
  variant: boolean;
};

const InnerTd = styled.td`
  border: solid 1px #d6e3eb;
  padding: 8px 12px;
  word-break: ${(props: innerTdType) => (props.num === 0 ? "keep-all" : "break-all")};
  background-color: ${(props: innerTdType) =>
    props.variant ? colors.themeColor("background_main") : colors.themeColor("background_whitegray")};
  ${(props: innerTdType) => (props.variant ? "border-top: transparent" : null)};
  width: 202px;
  &:last-child {
    width: auto;
  }
`;

const Table = ({ tableData = [], variant = false, url }: { tableData: string[]; variant: boolean; url: string }) => {
  const tableItem = () => {
    const recordArray: ReactNode[] = [];
    for (let i = 0; i < tableData.length; i++) {
      recordArray.push(
        <InnerTd variant={variant} key={i} num={i}>
          {url && i === 1 && !variant ? (
            <AnotherTabLink href={tableData[i]}>{tableData[i]}</AnotherTabLink>
          ) : (
            tableData[i]
          )}
        </InnerTd>,
      );
    }
    return recordArray;
  };

  return (
    <TableWrapper>
      <tbody>
        <tr>{tableItem()}</tr>
      </tbody>
    </TableWrapper>
  );
};

export default Table;
